﻿<template>
    <!--PrimeVue4已移除p-input-icon-right, 需使用IconField/InputIcon達成-->
    <!--InputText加上右方的清除按鈕-->
    <IconField>
        <!-- front icon -->
        <InputIcon v-if="$attrs.icon" :class="$attrs.icon" />
        <InputText ref="inputEx" @focus="isFocus=true" @blur="isFocus=false" v-bind="$attrs"></InputText>
        <!-- @mousedown.capture.stop 修正 Dialogic @mousedown 觸發處理函式會錯誤的問題  -->
        <InputIcon class="fas fa-times cursor-pointer" @mousedown.self.stop="onClear" v-if="isClear&&isFocus&&!$attrs.readonly" />
    </IconField>
</template>

<style scoped>
</style>

<script lang="ts">
    export default {
        name: module$.inputTextEx,
        inheritAttrs: true,
        customOptions: {}
    }
</script>

<script setup lang="ts">
    import { ref, computed } from 'vue'
    import { module$ } from '../enums'

    //***************工具物件***************
    const emit = defineEmits(['clear']);

    //***************元件屬性|計算**********
    const inputEx = ref();
    const isFocus = ref(false);
    const isClear = computed(() => (inputEx.value && inputEx.value.modelValue) ? true : false);

    //***************元件函式***************
    const onClear = (e) => {
        //左鍵才清除
        if (e.button == 0) {
            inputEx.value.$emit('update:modelValue', '');
            emit('clear');
        }
    }

    //***************元件監看***************

    //***************元件鉤子***************

</script>
